module.exports = __webpack_public_path__ + "img/ft_logo.f0cf6654.png";